import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_PATH, API_DEV_SLA, APP_NOTIFICATION, API_SLA } from '../../globals';
import { AUTH_SERVICE } from '../contexts/authContext';

export const baseApi = createApi({
    reducerPath: 'portrApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_PATH,
        validateStatus: (response, meta) => {
            if (response.status === 401) {
                AUTH_SERVICE.logout();
            }
            return true;
        }
    }),
    keepUnusedDataFor: 0,
    endpoints: () => ({}),
});

export const baseApiSla = createApi({
    reducerPath: 'portrApiSla',
    baseQuery: fetchBaseQuery({
        baseUrl: API_SLA,
        validateStatus: (response, meta) => {
            if (response.status === 401) {
                AUTH_SERVICE.logout();
            }
            return true;
        }
    }),
    keepUnusedDataFor: 0,
    endpoints: () => ({}),
});

export const notificationBaseApi = createApi({
    reducerPath: 'app_notification',
    baseQuery: fetchBaseQuery({ baseUrl: APP_NOTIFICATION }),
    keepUnusedDataFor: 0,
    endpoints: () => ({}),
});
